import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Info } from "react-feather";
import EmployeePhoto from "./EmployeePhoto";
import { useGetPassTypeByIdQuery } from "AppQuries/master/PassType/pass-type";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";
import { useFormattedEmpContractOption } from "core/Operations/formattedOption/useFormattedEmployeeOptions";

const ContractDetails = ({ employee }) => {
  const contratcOptions = useFormattedEmpContractOption(employee?.companyCode);
  return (
    <div className="view-employee-box mb-3">
      <div className="view-title">
        <h4>Contract Details</h4>
      </div>
      <div className="view-employee-content">
        <div className="row">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Contract Type</th>
                  <th>Duration</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Issue By</th>
                  <th>Active Status</th>
                </tr>
              </thead>
              <tbody>
                {employee?.contractDetails?.map((a) => (
                  <tr key={a.code}>
                    <td>
                      {contratcOptions.find((c) => c.value === a.contractType)
                        ?.label || ""}
                    </td>
                    <td>{a.duration}</td>
                    <td>
                      {a.contractStartDate &&
                        format(new Date(a.contractStartDate), "yyyy-MM-dd")}
                    </td>
                    <td>
                      {a.contractExpiryDate &&
                        format(new Date(a.contractExpiryDate), "yyyy-MM-dd")}
                    </td>
                    <td>{a.issuedBy}</td>
                    <td>{a.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

ContractDetails.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default ContractDetails;
